<ng-template [ngIf]="templateBtn">
    <div id="modal-container" *ngIf="!isCloseModal">
        <div class="modal open-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog-box" role="document">
                <div class="modal-content" [ngClass]="type">
                    <!--Popup Header -->
                    <div *ngIf="isHeaderVisible" class="common-modal-header">
                        <div class="form-row sp-btw">
                        <div class="form-item">
                            <h3>{{headerTitle | translate}}</h3>
                        </div>   
                        </div>
                    </div>
                    <!-- Popup content -->
                    <div [ngClass]="component==='aliasComponent'?'w-auto modal-body-container':'modal-body-container'">
                        <ng-container [ngTemplateOutlet]="showModalContent"></ng-container>
                    </div>
                    <!-- Interactive Buttons -->
                    <div class="popup-footer" *ngIf="isFooterVisible" [ngClass]=" isInfoSectionAvailable ? 'popup-footer-info':'popup-footer' ">
                        <div class="button-region" *ngIf="isInfoSectionAvailable">
                            <span class="icon icon_info_round"></span>
                            <span>{{'BP_EM_UPLOAD_IMP_INFO' | translate}}</span>
                        </div>
                        <div class="button-region">
                            <button *ngIf="isCloseButtonVisible" class="delta" (click)="close()">                           
                                  <span>{{(closeButtonTitle | translate) ? (closeButtonTitle | translate):closeButtonTitle}}</span>
                            </button>

                            <div *ngIf="isSaveButtonVisible" class="save-button-wrapper"
                                 (mouseenter)="showButtonTooltip = true"
                                 (mouseleave)="showButtonTooltip = false">
                                <app-generic-tooltip *ngIf="showButtonTooltip && showToolTip && doneButtonDisabled === 'INVALID'" [tooltip]="'BP_EM_ENGLISH_UPLOAD_IMP_INFO'" position="top" [anchorPos]="'top-center'"> </app-generic-tooltip>
                                <button class="beta" (click)="save()" [disabled]="doneButtonDisabled === 'INVALID'" [attr.aria-disabled]="doneButtonDisabled === 'INVALID'" [ngClass]="{'done-button-disable': doneButtonDisabled === 'INVALID' }">
                                    <span>{{(saveButtonTitle | translate) ? (saveButtonTitle | translate):saveButtonTitle}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template [ngIf]="!templateBtn">
    <div id="modal-container" *ngIf="!isCloseModal">
        <div class="modal open-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog-box" role="document">
                <div class="modal-content" [ngClass]="type">
                    <div
                        [ngClass]="component==='partcipantsQrDownload'?'common-modal-header common-modal-header-qr':'common-modal-header'">
                        <div class="form-row sp-btw row-padding">
                        <div class="form-item">
                            <h3>{{headerTitle | translate}}</h3>
                        </div>   
                        <div class="form-group">
                        
                        </div>
                        </div>
                    </div>
                    <div
                        [ngClass]="component==='partcipantsQrDownload'?'partcipant-qr modal-body-container':'modal-body-container'">
                        <ng-container [ngTemplateOutlet]="showModalContent"></ng-container>
                    </div>
                    <div class="form-group footer-section" *ngIf="isFooterVisible">
                        <div class="button-region">

                            <button *ngIf="isCloseBtnVisible" class="delta" (click)="close()">
                                <span>{{closeButtonTitle}}</span>
                            </button>

                            <button class="delta" (click)="close()">
                               <span>{{'BP_CM_CLOSE_BTN_LBL' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>